module.exports = __webpack_public_path__ + "img/logo.8eeb5dfe.svg";